'use strict';

const GAP = 32;
const containerMarginMobile = "16px";
const breakpoints = {
    phoneMini: {
        min: 0,
        max: 319
    },
    phoneSmall: {
        min: 320,
        max: 374
    },
    phone: {
        min: 375,
        max: 599
    },
    phoneLarge: {
        min: 600,
        max: 767
    },
    tablet: {
        min: 768,
        max: 959 + 2 * GAP
    },
    desktop: {
        min: 960 + 2 * GAP,
        max: 1151 + 2 * GAP
    },
    widescreen: {
        min: 1152 + 2 * GAP,
        max: 1215 + 2 * GAP
    },
    fullHD: {
        min: 1216 + 2 * GAP,
        max: Number.MAX_SAFE_INTEGER
    }
};
// Phone small 320px (iPhone SE, 5S)
const phoneSmall = `${breakpoints.phoneSmall.min}px`;
const phoneLargeMax = `${breakpoints.phoneLarge.max}px`;
// Tablet 768px
const tablet = `${breakpoints.tablet.min}px`;
const tabletMax = `${breakpoints.tablet.max}px`;

exports.breakpoints = breakpoints;
exports.containerMarginMobile = containerMarginMobile;
exports.phoneLargeMax = phoneLargeMax;
exports.phoneSmall = phoneSmall;
exports.tablet = tablet;
exports.tabletMax = tabletMax;
//# sourceMappingURL=dimensions.cjs.map
